/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-07-07",
    versionChannel: "nightly",
    buildDate: "2024-07-07T00:06:29.958Z",
    commitHash: "9394f7788cbbe750f3eb2a1e92f286737c6c80d6",
};
